import React, { useState, useEffect } from 'react';
import { Youtube, Instagram, Menu, X } from 'lucide-react';
import { socialLinks } from '../data/mockData';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header 
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled ? 'bg-white shadow-md py-3' : 'bg-transparent py-5'
      }`}
    >
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_flashcards-direito/artifacts/8s6fjaif_logo-canal.jpg" 
              alt="Direito em 5 Minutos" 
              className="h-12 md:h-16 w-auto object-contain"
            />
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            <button 
              onClick={() => scrollToSection('produtos')}
              className="text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              Produtos
            </button>
            <button 
              onClick={() => scrollToSection('como-funciona')}
              className="text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              Como Funciona
            </button>
            <button 
              onClick={() => scrollToSection('conteudo-gratuito')}
              className="text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              Conteúdo Gratuito
            </button>
            <button 
              onClick={() => scrollToSection('depoimentos')}
              className="text-gray-700 hover:text-blue-900 transition-colors font-medium"
            >
              Depoimentos
            </button>
          </nav>

          {/* Social Links */}
          <div className="hidden md:flex items-center space-x-4">
            <a 
              href={socialLinks.youtube}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 bg-red-600 text-white px-4 py-2 rounded-lg hover:bg-red-700 transition-all duration-300 transform hover:scale-105"
            >
              <Youtube size={20} />
              <span className="font-medium">YouTube</span>
            </a>
            <a 
              href={socialLinks.instagram}
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center space-x-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-2 rounded-lg hover:from-purple-700 hover:to-pink-700 transition-all duration-300 transform hover:scale-105"
            >
              <Instagram size={20} />
              <span className="font-medium">Instagram</span>
            </a>
          </div>

          {/* Mobile Menu Button */}
          <button 
            className="md:hidden text-gray-700"
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
          >
            {isMobileMenuOpen ? <X size={28} /> : <Menu size={28} />}
          </button>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <div className="md:hidden mt-4 pb-4 border-t border-gray-200 pt-4">
            <nav className="flex flex-col space-y-3">
              <button 
                onClick={() => scrollToSection('produtos')}
                className="text-gray-700 hover:text-blue-900 transition-colors font-medium text-left"
              >
                Produtos
              </button>
              <button 
                onClick={() => scrollToSection('como-funciona')}
                className="text-gray-700 hover:text-blue-900 transition-colors font-medium text-left"
              >
                Como Funciona
              </button>
              <button 
                onClick={() => scrollToSection('conteudo-gratuito')}
                className="text-gray-700 hover:text-blue-900 transition-colors font-medium text-left"
              >
                Conteúdo Gratuito
              </button>
              <button 
                onClick={() => scrollToSection('depoimentos')}
                className="text-gray-700 hover:text-blue-900 transition-colors font-medium text-left"
              >
                Depoimentos
              </button>
              <div className="flex flex-col space-y-2 pt-3">
                <a 
                  href={socialLinks.youtube}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center space-x-2 bg-red-600 text-white px-4 py-2 rounded-lg"
                >
                  <Youtube size={20} />
                  <span className="font-medium">YouTube</span>
                </a>
                <a 
                  href={socialLinks.instagram}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-center space-x-2 bg-gradient-to-r from-purple-600 to-pink-600 text-white px-4 py-2 rounded-lg"
                >
                  <Instagram size={20} />
                  <span className="font-medium">Instagram</span>
                </a>
              </div>
            </nav>
          </div>
        )}
      </div>
    </header>
  );
};

export default Header;
